import { langObject_en } from "./languageblob_en";
import { langObject_es } from "./languageblob_es";
import { langObject_cn } from "./languageblob_cn";

export const CheckLanguage = (dbFormSpec) => {
    if (dbFormSpec) {
        if (dbFormSpec.languageOverride) {
            return dbFormSpec.languageOverride;
        }
        else if (dbFormSpec.context) {
            if (dbFormSpec.context.languageOverride) {
                return dbFormSpec.context.languageOverride;
            }
        }
    }
    return "default";
};

export const GetLanguageText = (languageID) => {
    const validLanguageIDs = ["en", "es", "cn"];
    if (validLanguageIDs.includes(languageID)) {
        switch (languageID) {
            case "en": return langObject_en;
            case "es": return langObject_es;
            case "cn": return langObject_cn;

            default: return langObject_en;
        }
    }

    return langObject_en;  // default to ENglish
}
